import React, { memo, forwardRef } from "react";
const SvgLeftandRightSubscriptandSuperscript = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect
        width={7}
        height={13}
        x={12.5}
        y={9.5}
        stroke="#717171"
        strokeDasharray="2 2"
        strokeLinejoin="round"
        rx={1.5}
      />
      <rect width={8} height={12} x={22} y={17} fill="#DBDBDB" rx={2} />
      <rect width={8} height={12} x={2} y={17} fill="#DBDBDB" rx={2} />
      <rect width={8} height={12} x={22} y={3} fill="#DBDBDB" rx={2} />
      <rect width={8} height={12} x={2} y={3} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgLeftandRightSubscriptandSuperscript.displayName =
  "SvgLeftandRightSubscriptandSuperscript";
const MemoForwardRef = memo(SvgLeftandRightSubscriptandSuperscript);
export default MemoForwardRef;
